import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject, take} from "rxjs";
import {RequirementTypesList} from "../../interfaces/requirement-types-list";
import {DataService} from "../../services/data.service";
import {RequirementType} from "../../interfaces/requirement-type";
import {OverlayService} from "../../overlay/overlay.service";
import {SelfAssessmentIntroComponent} from "./self-assessment-intro/self-assessment-intro.component";
import {ProjectAreaService} from "../../services/project-area.service";
import {ProjectArea} from "../../enums/project-area";
import {GamesService} from "../../services/games.service";

@Injectable({
  providedIn: 'root'
})
export class SelfAssessmentService {

  public totalPageNumber = 5;
  private _currentPageNumber = new BehaviorSubject<number>(1);

  private _requirementsList = new BehaviorSubject<RequirementType[]>([]);


  constructor(private data: DataService, private overlay: OverlayService, private projectAreaService: ProjectAreaService, private gamesService: GamesService) {
    this.data.getAllJobRequirementTypes().pipe(take(1)).subscribe((types) => {
      let typesAsArr = [
        types.expertiseRequirements,
        types.selfRequirements,
        // types.furtherRequirements,
        types.methodologicalRequirements,
        types.physicalRequirements,
        types.socialRequirements
      ];

      typesAsArr = typesAsArr.sort(function (a, b) {
        if(a.bicId > b.bicId) return 1;
        if(a.bicId < b.bicId) return -1;
        return 0;
      })

      this._requirementsList.next(typesAsArr);
      this.totalPageNumber = Object.keys(types).length;
    })
  }

  getRequirementsList(): Observable<RequirementType[]> {
    return this._requirementsList;
  }

  setPreviousPageNumber() {
    const currPageNumber = this._currentPageNumber.getValue();
    if(currPageNumber > 1) {
      this._currentPageNumber.next(currPageNumber - 1);
    }
  }

  setNextPageNumber() {
    const currPageNumber = this._currentPageNumber.getValue();
    if(currPageNumber <= this.totalPageNumber) {
      this._currentPageNumber.next(currPageNumber + 1);
    }
  }

  goToStart() {
    this._currentPageNumber.next(1);
  }

  onCurrentPageNumberChanged(): Observable<number> {
    return this._currentPageNumber;
  }

  setSelfAssessmentLocalStorage() {
    window.localStorage.setItem("self-assessment", "1");
  }

  isSelfAssessmentVisited() {
    return window.localStorage.getItem("self-assessment") === "1"
  }

  showOnAppLoadIfNotVisited() {
    if(!this.isSelfAssessmentVisited()) {
      setTimeout(() => {
        if(!this.isSelfAssessmentVisited()) {
          if(this.projectAreaService.getCurrentArea() === ProjectArea.DEFAULT && !this.gamesService.getIsUserInGame()) {
            this.overlay.addComponent({
              component: SelfAssessmentIntroComponent,
              data: {}
            })
          } else {
            this.showOnAppLoadIfNotVisited();
          }


        }
      }, 50000);
    }
  }
}
